import React from 'react'
import styles from './NewChargePointFormView.module.scss'
import { NewChargePointData, NewChargePointDataErrors } from '../NewChargePointFormPresenter';
import { UserRole } from '../../../../../user/types/user.types';
import Button from '../../../../../../common/components/atom/Button/Button';
import TextInput from '../../../../../../common/components/atom/TextInput/TextInput';
import MessageCard from '../../../../../../common/components/molecule/MessageCard/MessageCard';

export interface NewChargePointFormViewProps {
  formData?: NewChargePointData;
  setFormData: (key: keyof NewChargePointData, value: string) => void;
  errorStatus?: NewChargePointDataErrors;
  handleSubmit?: () => void;
  messageError?: string | null;
  isLoading?: boolean;
  submitLabel?: string;
  description?: string;
  title?: string;
  maxWidth?: string;
  currentUserRoleCreator?: UserRole;
}
export default function NewChargePointFormView({
  handleSubmit,
  messageError,
  errorStatus,
  isLoading,
  submitLabel = "Créer",
  description = "Saisissez les informations de la nouvelle borne",
  maxWidth = "700px",
  title,
  formData,
  setFormData,
  currentUserRoleCreator,
}: NewChargePointFormViewProps) {
  return (
    <div style={{ maxWidth: maxWidth }}>
      <div className={[styles["container"]].join(" ")}>
        {title && (
          <h1 className={[styles["container__title"]].join(" ")}>{title}</h1>
        )}
        <p className={[styles["container__description"]].join(" ")}>
          {description}
        </p>
        <div className={[styles["container__error-message"]].join(" ")}>
          <MessageCard variant="danger" message={messageError} width100 />
        </div>
        <form
          className={[styles["form"]].join(" ")}
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit && handleSubmit();
          }}
        >
          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label="Nom de la borne"
              value={formData?.name}
              error={errorStatus?.isErrorName}
              onChange={(e) => {
                setFormData("name", e.target.value);
              }}
            />
          </div>

          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label="Device ID"
              value={formData?.hardwareId}
              error={errorStatus?.isErrorHardwareId}
              onChange={(e) => {
                setFormData("hardwareId", e.target.value);
              }}
            />
          </div>
         
     
          <div className={[styles["form__button-container"]].join(" ")}>
            <div className={[styles["form__button-container__item"]].join(" ")}>
              <Button
                isLoading={isLoading}
                onClick={handleSubmit}
                type={"submit"}
              >
                {submitLabel}
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>)
}
